'use client';
import { NewExperiencePage } from '../components/new-experience-page/new-experience-page';

export default function ExperiencePage() {
  return <NewExperiencePage />;
}
